<template>
    <div>
        <v-row id="facility__photos">
            <v-col cols="12">
                <h2 class="mt-4">Facility Photos</h2>
            </v-col>
            <v-col
              cols="6"
              sm="4"
              md="3"
              lg="2"
              v-for="photo in currentFacility.images"
              :key="photo.id"
            >
                <v-img
                    :src="imageBasePath + photo.url"
                    aspect-ratio="1"
                >
                    <v-row
                        class="fill-height ma-0"
                        slot="placeholder"
                        align="center"
                        justify="center"
                    >
                        <v-progress-circular indeterminate color="grey" />
                    </v-row>
                </v-img>
                <v-btn
                    data-testid="facility-photos-delete-btn"
                    class="facility-photos-delete-btn my-3"
                    color="error"
                    block
                    small
                    @click="openDelete(photo)"
                >
                    Delete
                </v-btn>
                <app-input
                    data-testid="facility-photos-order-input"
                    class="facility-photos-order-input"
                    :type="'text'"
                    label="Order"
                    v-model.trim="photo.order"
                />
                <app-input
                    data-testid="facility-photos-alt-text-input"
                    class="facility-photos-alt-text-input mb-0 pb-0"
                    :type="'text'"
                    label="Alt Text"
                    v-model.trim="photo.alt"
                />
            </v-col>
            <v-col
              cols="4"
              sm="3"
              lg="2"
              v-if="currentFacility.images.length < 10"
            >
                <add-photo
                    data-testid="facility-photos-upload-btn"
                    class="facility-photos-upload-btn"
                    dispatchMethod="uploadFacilityImage"
                />
            </v-col>

        </v-row>
        <delete-modal
            v-model="modal"
            @delete="deletePhoto"
            :itemType="'photo'"
            :advisory="advisory"
        />
    </div>
</template>

<script>
import AddPhoto from "@/components/AddPhoto.vue";
import AppInput from "@/components/global/AppInput";
import DeleteModal from "@/components/DeleteModal.vue";
import { genericAdvisory } from "@/helpers/warning-advisory-text";

export default {
  data() {
    return {
      advisory: genericAdvisory,
      imageBasePath: process.env.VUE_APP_PHOTO_BASE_PATH + "/",
      loading: false,
      modal: false,
      selectedPhoto: ""
    };
  },

  computed: {
    currentFacility: {
      get() {
        return this.$store.state.facility.currentFacility;
      },
      set(newValue) {
        this.$store.commit("setCurrentFacilityData", newValue);
      }
    }
  },

  components: {
    AddPhoto,
    AppInput,
    DeleteModal
  },

  methods: {
    openDelete(photo) {
      this.modal = true;
      this.selectedPhoto = photo;
    },

    async deletePhoto() {
      this.loading = true;
      this.$store.dispatch("deleteImage", this.selectedPhoto.id)
        .then(() => {
          this.loading = false;
          this.$store.dispatch("getFacility", this.currentFacility.id);
          this.selectedPhoto = "";
          this.modal = false;
        });
    }
  }
};
</script>
